import { render, staticRenderFns } from "./InitialGopages.vue?vue&type=template&id=7f3eae2e"
import script from "./InitialGopages.vue?vue&type=script&lang=js"
export * from "./InitialGopages.vue?vue&type=script&lang=js"
import style0 from "./InitialGopages.vue?vue&type=style&index=0&id=7f3eae2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports